import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Dropdown, Option } from "./Dropdown";
import { Form, Button } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const EditLeads = ({ history, match }) => {
  const [users, setUsers] = useState([]);
  const [dap_name, setName] = useState("");
  const [dap_lastname, setLastName] = useState("");
  const [dap_role, setRole] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_dob, setDOB] = useState("");
  const [dap_industry, setIndustry] = useState("");
  const [dap_package, setPackage] = useState({});
  const [visible, setVisible] = useState(false);
  const [dap_organization, setOrganization] = useState("");
  const [dap_billable, setBillable] = useState(false);
  const [dap_billable1, setBillable1] = useState(false);
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [organizationErrors, setOrganizationErrors] = useState({});
  const [zipErrors, setZipErrors] = useState({});
  const [region, setRegion] = useState("");
  const [dap_designation, setDesignation] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [countryErrors, setCountryErrors] = useState({});
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [phoneErrors, setPhoneErrors] = useState({});
  const [goBackLink, setGoBackLink] = useState("");
  const [designationErrors, setDesignationErrors] = useState({});
  const [dap_source, setSource] = useState("");
  const [sourceErrors, setSourceErrors] = useState({});
  const [industryErrors, setIndustryErrors] = useState({});
  const [dap_awareness, setAwareness] = useState("");
  const [awarenessErrors, setAwarenessErrors] = useState({});
  const [dap_interest, setInterest] = useState("");
  const [interestErrors, setInterestErrors] = useState({});
  const [probabilityErrors, setProbabilityErrors] = useState({});
  const [dap_probability, setProbability] = useState("");
  const [cityErrors, setCityErrors] = useState({});
  const [addressErrors, setAddressErrors] = useState({});
  const [stateErrors, setstateErrors] = useState({});
  const [response, getresponse] = useState({});
  const [packageError, setPackageError] = useState("");
  const dap_user_id = match.params.id;
  let roles = [];
  roles = [
    {
      roleType: "Trial",
      roleId: 1,
    },
    {
      roleType: "Diamond", //"Basic"
      roleId: 2,
    },
    {
      roleType: "Gold",  //"Advance",
      roleId: 3,
    },
    {
      roleType: "Silver",  //"Corporate",
      roleId: 4,
    },
  ];
  let roles1 = [];
  roles1 = [
    {
      roleType: "Email",
      roleId: 1,
    },
    {
      roleType: "Website",
      roleId: 2,
    },
    {
      roleType: "Social Media",
      roleId: 3,
    },
    {
      roleType: "Campaign",
      roleId: 4,
    },
    {
      roleType: "TradeShow",
      roleId: 5,
    },
    {
      roleType: "Events",
      roleId: 6,
    },
    {
      roleType: "Others",
      roleId: 7,
    },
  ];
  let roles2 = [];
  roles2 = [
    {
      roleType: "Corporate",
      roleId: 1,
    },
    {
      roleType: "Education",
      roleId: 2,
    },
    {
      roleType: "Healthcare",
      roleId: 3,
    },
    {
      roleType: "Hospitality",
      roleId: 4,
    },
    {
      roleType: "Manufacturing",
      roleId: 5,
    },
    {
      roleType: "Others",
      roleId: 5,
    },
  ];
  let roles3 = [];
  roles3 = [
    {
      roleType: "1",
      roleId: 1,
    },
    {
      roleType: "2",
      roleId: 2,
    },
    {
      roleType: "3",
      roleId: 3,
    },
    {
      roleType: "4",
      roleId: 4,
    },
    {
      roleType: "5",
      roleId: 5,
    },
  ];
  let roles4 = [];
  roles4 = [
    {
      roleType: "1",
      roleId: 1,
    },
    {
      roleType: "2",
      roleId: 2,
    },
    {
      roleType: "3",
      roleId: 3,
    },
    {
      roleType: "4",
      roleId: 4,
    },
    {
      roleType: "5",
      roleId: 5,
    },
  ];
  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  states = State.getAllStates();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };

  //   console.log(Country.getAllCountries());
  //   console.log(Country.getAllCountries());
  //   console.log(State.getAllStates());
  useEffect(() => {
    console.log(dap_billable);

    if (dap_billable == true) {
      setVisible(true);
    } else {
      setVisible(false);
    }

    let id = match.params.id;
    //  console.log(id);getLead(id);
    console.log(id);

    if (localStorage.getItem("isLeadExecutive")) {
      setGoBackLink("/get-leads");
    } else {
      setGoBackLink("/addleads");
    }

    axios
      .get(environment.dap_url + "crm_api/getLeadsById?id=" + id)
      .then((res) => {
        // getresponse(res.data);
        // if (res.data.hasOwnProperty("package")) {
        //   handlechange_new("yes");
        // }
        const dap_users = res.data;
        // console.log(res.data.package);
        console.log(res);
        console.log("hello");
        setUsers(res.data);
        setEmail(res.data.email);
        setName(res.data.userFirstName);
        setLastName(res.data.userLastName);
        setOrganization(res.data.organization);
        setPhone(res.data.phone);
        setAddress(res.data.address);
        setPostCountry(res.data.country);
        setPostState(res.data.state);
        setPostCity(res.data.city);
        setZip(res.data.zip);
        setBillable(res.data.isBillable);
        setDesignation(res.data.designation);
        setSource(res.data.source);
        setIndustry(res.data.industry);
        setAwareness(res.data.awareness);
        setInterest(res.data.interest);
        setProbability(res.data.probability);
        setPackage(res.data.package);
        if (res.data.isBillable == true) {
          setVisible(true);
        }
        console.log(res.data);
        var output = document.getElementById("percent");
        output.innerHTML = res.data.probability + "%";
        // setLoader(false);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const formValidation = () => {
    const emailErrors = {};
    const nameErrors = {};
    const phoneErrors = {};
    const designationErrors = {};
    const organizationErrors = {};
    const lastnameErrors = {};
    const sourceErrors = {};
    const industryErrors = {};
    const awarenessErrors = {};
    const interestErrors = {};
    const countryErrors = {};
    const stateErrors = {};
    const cityErrors = {};
    const zipErrors = {};
    const probabilityErrors = {};
    const addressErrors = {};
    const packageError = {};
    let isValid = true;

    if (!dap_email) {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(dap_email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    }
    //  else if (dap_email == e.target.value) {
    //   emailErrors.duplicateEmail = "* Email address is already exist";
    //   isValid = false;
    // }
    if (!dap_name) {
      nameErrors.noName = "* Name is required";
      isValid = false;
    } else if (dap_name.trim().length < 2) {
      nameErrors.shortName = "* First Name is too short";
      isValid = false;
    }
    if (!dap_organization) {
      organizationErrors.noOrganization = "* Organization is required";
      isValid = false;
    } else if (dap_organization.trim().length < 1) {
      organizationErrors.shortOrganization = "* Organization is too short";
      isValid = false;
    }
    if (!dap_designation) {
      designationErrors.noDesignation = "* Designation is required";
      isValid = false;
    } else if (dap_designation.trim().length < 1) {
      designationErrors.shortDesignation = "* Designation is too short";
      isValid = false;
    }
    if (!dap_source) {
      sourceErrors.noSource = "* Source Field is required";
      isValid = false;
    } else if (dap_source.trim().length < 2) {
      sourceErrors.shortSource = "* Source is too short";
      isValid = false;
    }
    if (!dap_industry) {
      industryErrors.noIndustry = "* Industry Field is required";
      isValid = false;
    } else if (dap_industry.trim().length < 1) {
      industryErrors.shortIndustry = "* Industry is too short";
      isValid = false;
    }
    if (!dap_awareness) {
      awarenessErrors.noAwareness = "* Awareness Field is required";
      isValid = false;
    }
    if (!dap_interest) {
      interestErrors.noInterest = "* Interest Field is required";
      isValid = false;
    }
    if (!postcountry) {
      countryErrors.noCountry = "* Country Field is required";
      isValid = false;
    } else if (postcountry.trim().length < 0) {
      countryErrors.shortCountry = "* Country name is too short";
      isValid = false;
    }
    if (!poststate) {
      stateErrors.noState = "* State Field is required";
      isValid = false;
    } else if (poststate.trim().length < 0) {
      stateErrors.shortState = "* State name is too short";
      isValid = false;
    }
    if (!postcity) {
      cityErrors.noCity = "* City Field is required";
      isValid = false;
    } else if (postcity.trim().length < 0) {
      cityErrors.shortCity = "* City name is too short";
      isValid = false;
    }
    if (!dap_probability) {
      probabilityErrors.noProbability = "* Probability Field is required";
      isValid = false;
    }

    if (!dap_address) {
      addressErrors.noAddress = "* Address Field is required";
      isValid = false;
    }
    if (!zip) {
      zipErrors.noZip = "* Zip Field is required";
      isValid = false;
    } else if (zip.trim().length != 6) {
      zipErrors.shortZip = "* Zip Should Contain 6 Digit";
      isValid = false;
    }
    if (!dap_phone) {
      phoneErrors.shortNumber = "* Phone number required";
      isValid = false;
    } else if (dap_phone.length > 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (dap_phone.length < 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,1024}$/.test(
        dap_phone
      )
    ) {
      phoneErrors.shortNumber = "Phone number should be 10 digits";
      isValid = false;
    }

    if (dap_billable) {
      if (dap_package == "") {
        packageError.shortPackage = "* Package is required";
        isValid = false;
      }
      console.log(dap_package, 1);
    }

    setOrganizationErrors(organizationErrors);
    setDesignationErrors(designationErrors);
    setEmailErrors(emailErrors);
    setNameErrors(nameErrors);
    setPhoneErrors(phoneErrors);
    setSourceErrors(sourceErrors);
    setIndustryErrors(industryErrors);
    setAwarenessErrors(awarenessErrors);
    setInterestErrors(interestErrors);
    setCountryErrors(countryErrors);
    setstateErrors(stateErrors);
    setCityErrors(cityErrors);
    setZipErrors(zipErrors);
    setAddressErrors(addressErrors);
    setProbabilityErrors(probabilityErrors);
    setPackageError(packageError);
    return isValid;
  };

  const handlechange_new = (e) => {
    const value = e.target.value;
    console.log(value);
    if (value === "yes") {
      setBillable(true);
      setVisible(true);
    }
    if (value === "no") {
      setBillable(false);
      setVisible(false);
      setPackage("");
    }
  };

  console.log(dap_billable);

  const setprob = (value) => {
    setProbability(value);
    var output = document.getElementById("percent");
    output.innerHTML = value + "%";
  };
  const submitHandler = () => {
    const isValid = formValidation();
    let id = match.params.id;
    console.log(id);
    console.log(isValid);
    if (isValid == true) {
      axios
        .put(
          //"user?sendActivationMail=true",
          environment.dap_url + "crm_api/updateLead?id=" + id,
          {
            name: dap_name,
            email: dap_email,
            source: dap_source,
            industry: dap_industry,
            designation: dap_designation,
            awareness: dap_awareness,
            interest: dap_interest,
            probability: dap_probability,
            phone: dap_phone,
            city: postcity,
            state: poststate,
            country: postcountry,
            address: dap_address,
            zip: zip,
            organization: dap_organization,
            billable: dap_billable,
            package: dap_package,

            //   userType: "LOGISTIC_MANAGER",
          }
        )
        .then((res) => {
          console.log("hello", res.data);
          history.push(goBackLink);
          MySwal.fire({
            title: <p>Lead has been successfully updated!</p>,
            type: "success",
          });
          //   history.push(`/users/${dap_user_id}`);
        })
        .catch((err) => {
          setLoading(false);
          MySwal.fire({
            title: (
              <p>{err?.response?.data?.message || "Lead update failed"}</p>
            ),
            type: "error",
          });
        });
    }
  };

  return (
    <div class="container-fluid">
      <NavbarNew />
      <div className="container-fluid">
        <div className="col-12">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <h4 className="card-title">Edit Leads :</h4>
              </div>
              <div class="col-md-6">
                <Link
                  to={goBackLink}
                  className="btn btn-light"
                  style={{ float: "right" }}
                >
                  Go Back
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginLeft: "4%", marginRight: "4%" }}>
        <Form>
          <div className="row">
            <div className="col-md-3">
              <Form.Group controlId="name">
                <Form.Label>*First Name</Form.Label>
                <Form.Control
                  type="title"
                  placeholder="First Name"
                  value={dap_name}
                  onChange={(e) => setName(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(nameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{nameErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group controlId="name">
                <Form.Label>*Last Name</Form.Label>
                <Form.Control
                  type="title"
                  placeholder="Last Name"
                  value={dap_lastname}
                  onChange={(e) => setLastName(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(nameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{nameErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group controlId="name">
                <Form.Label>Organization</Form.Label>
                <Form.Control
                  type="title"
                  placeholder="Organization"
                  value={dap_organization}
                  onChange={(e) => setOrganization(e.target.value)}
                ></Form.Control>
                {/* <div>
                  {Object.keys(nameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{nameErrors[key]}</div>
                    );
                  })}
                </div> */}
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="designation">
                <Form.Label>*Designation</Form.Label>
                <Form.Control
                  type="required"
                  // message="Organization field required"
                  placeholder="Designation"
                  value={dap_designation}
                  onChange={(e) => setDesignation(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(designationErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>
                        {designationErrors[key]}
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>

            <div>
              {/* <div class="dropdown"> */}
              {/* <Form.Group controlId="name">
                <Form.Label> Role</Form.Label>
                <Select
                  options={roles.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  // value={dap_role}
                  onChange={(e) => setRole(e)}
                  placeholder="Choose Roles "
                />
              </Form.Group> */}
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>* Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={dap_email}
                  readOnly={true}
                  onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(emailErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{emailErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="role">
                <Form.Label>* Phone</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Phone"
                  value={dap_phone}
                  onChange={(e) => setPhone(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(phoneErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{phoneErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label style={{ marginTop: 35 }}>BILLABLE </Form.Label>
                <input
                  name="billable"
                  id="yes"
                  type="radio"
                  value="yes"
                  // value={true}
                  // value={dap_billable}
                  checked={dap_billable}
                  // onFocus
                  onChange={handlechange_new}
                  style={{ marginTop: 35, marginLeft: 10 }}
                />
                {""}
                Yes
                <span> </span>
                <input
                  name="billable"
                  id="no"
                  type="radio"
                  value="no"
                  // value={false}
                  // value={dap_billable}
                  checked={!dap_billable}
                  onChange={handlechange_new}
                  style={{ marginTop: 24 }}
                />
                {""}
                No
              </Form.Group>
            </div>
            {visible && (
              <div className="col-3">
                <Form.Group controlId="name">
                  <Form.Label> Package</Form.Label>
                  <Select
                    options={roles.map((element) => ({
                      id: element.roleType,
                      value: element.roleType,
                      label: element.roleType,
                    }))}
                    value={{
                      label: dap_package,
                      value: dap_package,
                    }}
                    // value={dap_role}
                    onChange={(e) => setPackage(e.value)}
                    placeholder="Choose Package "
                  />
                  <div>
                    {Object.keys(packageError).map((key) => {
                      return (
                        <div key={key} style={{ color: "red" }}>
                          {packageError[key]}
                        </div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-3">
              <Form.Group controlId="source">
                <Form.Label>*Source</Form.Label>
                <Select
                  options={roles1.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  value={{
                    label: dap_source,
                    value: dap_source,
                  }}
                  onChange={(e) => setSource(e.value)}
                  placeholder="Choose Source "
                />
                <div>
                  {Object.keys(sourceErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{sourceErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="industry">
                <Form.Label>*Industry</Form.Label>
                <Select
                  options={roles2.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  value={{
                    label: dap_industry,
                    value: dap_industry,
                  }}
                  // onChange={setothers}
                  onChange={(e) => setIndustry(e.value)}
                  placeholder="Choose Industry "
                />
                <div>
                  {Object.keys(industryErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{industryErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="awareness">
                <Form.Label>*Awareness</Form.Label>
                <Select
                  options={roles3.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  value={{
                    label: dap_awareness,
                    value: dap_awareness,
                  }}
                  onChange={(e) => setAwareness(e.value)}
                  placeholder="Choose Awareness "
                />
                <div>
                  {Object.keys(awarenessErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{awarenessErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="interest">
                <Form.Label> *Interest</Form.Label>
                <Select
                  options={roles4.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  value={{
                    label: dap_interest,
                    value: dap_interest,
                  }}
                  onChange={(e) => setInterest(e.value)}
                  placeholder="Choose Interest "
                />
                <div>
                  {Object.keys(interestErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{interestErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <Form.Group
                controlId="name
              "
              >
                <Form.Label>Country</Form.Label>
                <Select
                  options={countries.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectCountry(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="Country"
                  value={{
                    id: "",
                    label: postcountry,
                    value: postcountry,
                  }}
                />
                <div>
                  {Object.keys(countryErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{countryErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>State</Form.Label>
                <Select
                  options={dap_states.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectRegion(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="State"
                  value={{ label: poststate, value: poststate }}
                />
                <div>
                  {Object.keys(stateErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{stateErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>City</Form.Label>
                <Select
                  options={dap_city.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectCity(e)}
                  // defaultValue={dap_deviceList[0].name}
                  // defaultValue="hi there"
                  placeholder="City"
                  value={{ label: postcity, value: postcity }}
                />
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="zip">
                <Form.Label>Zip</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter postal code"
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-9">
              <Form.Group controlId="address">
                <Form.Label> Address</Form.Label>
                <Form.Control
                  type="address"
                  placeholder="Address"
                  value={dap_address}
                  onChange={(e) => setAddress(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="probability">
                <Form.Label> *Probability</Form.Label>
                <div>
                  <label for="customRange1" class="form-label"></label>
                  <input
                    type="range"
                    class="form-range"
                    min="0"
                    max="100"
                    step="1"
                    id="customRange1"
                    value={dap_probability}
                    onChange={(e) => setprob(e.target.value)}
                  ></input>
                  <label for="percent" id="percent"></label>
                </div>
                <div>
                  {Object.keys(probabilityErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>
                        {probabilityErrors[key]}
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
        </Form>
        <div className="col-4" style={{ marginTop: "2%", marginLeft: "91%" }}>
          <button
            type="submit"
            class="btn btn-primary m-1"
            style={{ float: "left" }}
            onClick={submitHandler}
          >
            SAVE
          </button>
          <Link to={goBackLink}>
            <button
              class="btn btn-warning m-1"
              style={{ backgroundColor: "red" }}
            >
              CANCEL
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EditLeads;
